import apiRequest from "./ApiRequest/apiRequest.js";

  /**
  * fetching data of global const-text
  */

 // okay, i see, so just either use this func like:
  const getFeatureBySystemName = async (
    systemName,
    language,
    setState,
    setLoadingPurchasePage = null
  ) => {
    const res = await apiRequest(
      "Features",
      "GetFeatureBySystemNameAndCulture",
      {
        systemName: systemName,
        culture: language,
      }
    );
    if (res.status === "success") {
      setState && setState(res.data);
      setLoadingPurchasePage && setLoadingPurchasePage(false);
    }else{
      setLoadingPurchasePage && setLoadingPurchasePage(false);
    }
  };

  export default getFeatureBySystemName;